import { useEffect, type ReactNode } from 'react';
import { Box } from '@mui/material';
import { WidgetPortalContext } from './embeddableWidgetPortalContext';
import { prepareEmbeddableWidgetContainer } from './embeddableWidgetPortalUtils';

interface WidgetPortalProviderProps {
  container: HTMLElement;
  children: ReactNode;
}

export function WidgetPortalProvider({
  container,
  children,
}: WidgetPortalProviderProps) {
  return (
    <WidgetPortalContext.Provider value={container}>
      {children}
    </WidgetPortalContext.Provider>
  );
}

interface EmbeddableWidgetShellProps {
  container: HTMLElement;
  children: ReactNode;
}

/** Wrapper rendered inside the host mount element for embeddable widgets. */
export function EmbeddableWidgetShell({
  container,
  children,
}: EmbeddableWidgetShellProps) {
  useEffect(() => {
    prepareEmbeddableWidgetContainer(container);
  }, [container]);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        minHeight: 0,
        isolation: 'isolate',
      }}
    >
      {children}
    </Box>
  );
}
